import React, { useState, useEffect } from "react";

import ICommonFormProps from "../../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import { IExtraGroup } from "../../../../interfaces/IExtraGroup";
import { FormTags } from "../../../../yoello-lib/modules/dynamicForms/CustomFormComponents/FormTags";

const KEYNAME = "extra_groups";

interface Props extends ICommonFormProps {
  setValue: (name: string, value: any) => void;
}

const AddToExtraGroup = (props: Props) => {
  const [selectOptions, setSelectOptions] = useState<any>();
  const [selected, setSelected] = useState<any>();

  useEffect(() => {
    const fetch = async () => {
      const data = props.formProps?.selectOptions as any;
      let selectOps: any[] = [];
      if (Array.isArray(data)) {
        selectOps = data.map((eG: IExtraGroup) => {
          return {
            ...eG,
            value: eG.id,
            name: eG.name_internal
          }
        });
      }
      setSelectOptions(selectOps);
    };

    fetch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetch = async () => {
      const extraGroups = props.getValues!(KEYNAME);
      setSelected(extraGroups);
    };
    fetch();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div style={{ marginTop: "1rem" }}></div>
      <FormTags
        {...props}
        keyName={KEYNAME}
        formProps={{
          ...props.formProps, selectOptions: selectOptions,
          getOptionLabel: (option: any) => option?.name_public,
          selectKeyValue: "id"
        }}
        value={selected}
      />
    </>
  );
};

export default AddToExtraGroup;
